import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DataGrid from '../../../../common/DataGrid/DataGrid';
import PropTypes from 'prop-types';
import { RawHtml } from '../../../../common';
import { DEFAULT_ATTRIBUTES } from '../../../../../utils/constants/meteo.js';
import { BatteryIcon } from '../../../../common/Meteo/BatteryIcon';
import { SignalIcon } from '../../../../common/Meteo/SignalIcon';
import { SeriousDeleteQuestion } from '../../../../common/DeleteQuestion/SeriousDeleteQuestion.jsx';

export function SensorsAttributesTable({ attributes, onEditClick, onDelete }) {
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      {
        title: t('Popis atribútu'),
        dataIndex: 'label',
        ellipsis: true,
      },
      {
        title: t('Kľúč atribútu'),
        dataIndex: 'key',
        ellipsis: true,
      },
      {
        title: t('Jednotka'),
        dataIndex: ['attribute_unit', 'unit'],
        ellipsis: true,
      },
      {
        title: t('Ikona'),
        dataIndex: 'icon',
        render: (icon, attribute) => (
          <div style={{ fontSize: '2rem' }}>
            {attribute.key === DEFAULT_ATTRIBUTES.BATTERY ? (
              <BatteryIcon percentage={100} />
            ) : attribute.key === DEFAULT_ATTRIBUTES.LINK_QUALITY ? (
              <SignalIcon percentage={100} />
            ) : (
              <RawHtml>{icon}</RawHtml>
            )}
          </div>
        ),
        ellipsis: true,
      },
    ],
    [t],
  );

  return (
    <DataGrid
      rowKey={(attribute) => attribute.id}
      columns={columns}
      dataSource={attributes}
      permissionsBasic={'meteo-station'}
      uniqueTableId={'meteo-station-sensors-attributes-table'}
      onRowClick={onEditClick}
      onEditClick={onEditClick}
      onDelete={onDelete}
      question={
        <SeriousDeleteQuestion
          firstText={t('Naozaj chcete vymazať tento atribút?')}
          mainNotice={t('S atribútom sa vymažú aj VŠETKY jeho hodnoty!')}
          lastText={t(
            'Prosím uistite sa, že mažete správny atribút, aby ste predišli nežiadúcim komplikáciam!',
          )}
        />
      }
    />
  );
}
SensorsAttributesTable.propTypes = {
  attributes: PropTypes.array.isRequired,
  onEditClick: PropTypes.func,
  onDelete: PropTypes.func,
};
